import { useState } from "react";

import { pdf } from "@react-pdf/renderer";

import {
  buildShipmentPDFShipment,
  ShipmentPDF,
} from "../components/Shipment/components/ShipmentPDF";
import { getPublicShipmentTrackingUrlOrNull } from "../utils";

interface UseSupplierShipmentPDFExportProps {
  supplierShipment: SupplierShipment;
}

export function useSupplierShipmentPDFExport(
  props: UseSupplierShipmentPDFExportProps,
) {
  const { supplierShipment } = props;
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const exportSupplierShipmentToPDF = async (
    sections: AppRenderedPDFSectionConfig[],
  ) => {
    setIsExporting(true);
    setError(null);
    try {
      const pdfShipment = buildShipmentPDFShipment(supplierShipment);

      const blob = await pdf(
        <ShipmentPDF
          shipment={pdfShipment}
          sections={sections}
          publicShipmentUrl={getPublicShipmentTrackingUrlOrNull({
            publicToken: supplierShipment.public_token,
            shipmentType: supplierShipment.info.type,
          })}
        />,
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `supplier-shipment-${supplierShipment.info.id}-export.pdf`;
      link.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      setError("Failed to generate PDF. Please try again.");
      throw err;
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportSupplierShipmentToPDF,
    isExporting,
    error,
  };
}
